const { reportSdkDiagnostic } = require('./sdkDiagnostics');

const DEFAULT_MAX_EVENTS = 200;

function normalizeMaxEvents(value) {
  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed < 1) {
    return DEFAULT_MAX_EVENTS;
  }
  return Math.min(Math.floor(parsed), 1000);
}

function sanitizeMetadata(metadata) {
  if (!metadata || typeof metadata !== 'object' || Array.isArray(metadata)) {
    return {};
  }

  const sanitized = {};
  Object.entries(metadata).forEach(([key, value]) => {
    if (value === undefined || typeof value === 'function') return;
    if (value === null || ['string', 'number', 'boolean'].includes(typeof value)) {
      sanitized[key] = value;
      return;
    }
    if (Array.isArray(value)) {
      sanitized[key] = value
        .filter((item) => item === null || ['string', 'number', 'boolean'].includes(typeof item))
        .slice(0, 50);
    }
  });
  return sanitized;
}

function createAdDiagnostics(options = {}) {
  const runtimeWindow = options.runtimeWindow
    || (typeof window !== 'undefined' ? window : null);
  const enabled = options.enabled === true;
  const maxEvents = normalizeMaxEvents(options.maxEvents);
  const context = sanitizeMetadata(options.context);
  const events = [];
  let sequence = 0;
  let destroyed = false;

  function record(type, metadata = {}) {
    // The sampled diagnostics beacon counts these even with the debug log off.
    if (type === 'auction_fallback' && metadata && metadata.reason === 'prebid_unavailable') reportSdkDiagnostic('prebid_unavailable');
    else if (type === 'auction_timed_out') reportSdkDiagnostic('prebid_timeout');
    if (!enabled || destroyed) return null;

    const event = {
      sequence: ++sequence,
      type: String(type || 'unknown'),
      timestamp: Date.now(),
      ...context,
      ...sanitizeMetadata(metadata)
    };
    events.push(event);
    if (events.length > maxEvents) {
      events.splice(0, events.length - maxEvents);
    }
    return event;
  }

  function snapshot() {
    return events.map((event) => ({ ...event }));
  }

  function clear() {
    events.length = 0;
  }

  const api = {
    enabled,
    record,
    snapshot,
    clear,
    destroy() {
      destroyed = true;
      if (runtimeWindow && runtimeWindow.__millaAdsDiagnostics === api) {
        delete runtimeWindow.__millaAdsDiagnostics;
      }
    }
  };

  if (enabled && runtimeWindow) {
    runtimeWindow.__millaAdsDiagnostics = api;
  }

  return api;
}

module.exports = {
  DEFAULT_MAX_EVENTS,
  createAdDiagnostics,
  sanitizeMetadata
};
